module.exports = __webpack_public_path__ + "img/recon-star.e28c4707.svg";